import { returnSchemeExcelDate } from '../datetime';
import { formatToINR, schemeTypeMap } from './constantsAndUtils';
import * as XLSX from 'xlsx';

export const exportSchemeDataSummary = (data, fileName, needData) => {
  const result =
    data &&
    data?.flatMap((item) =>
      item.products.map((row) => {
        return {
          CreationDate: returnSchemeExcelDate(item?.createdAt),
          CreatedBy: item?.actionLog?.[0]?.user,
          SchemeNo: item.voucherNumber,
          Brand: item?.company?.join(', '),
          SchemeType: item.type[0],
          SubType: item.sellIntype?.[0],
          SchemeCircularDate: returnSchemeExcelDate(item?.schemeCircularDate),
          SchemeCircularNo: item.schemeCircularNo,
          ValidFrom: returnSchemeExcelDate(item?.validFrom),
          ValidTill: returnSchemeExcelDate(item?.validTill),
          Regions: item.regions?.join(','),
          ProductCategory: item?.productCategory?.join(', '),
          SubCategory: item?.subCategory?.join(', '),
          SubCategory2: item?.subCategory2?.join(', '),
          SubCategory3: item?.subCategory3?.join(', '),
          Product: row?.productName,
          VAN: row?.vanNo,
          ValuationType: row?.valuationType,
          Payout: formatToINR(row?.payout || 0),
          PayoutBasis: item.payoutBasis?.[0] || row?.payoutBasis?.[0],
          CappingType: row.cappingType?.[0],
          'Capping Value/Qty': formatToINR(row?.cappingAmount || 0),
          Target: row.target,
          VSAmount: formatToINR(row.vsAmount || 0),
          'Brand Amount': formatToINR(row.brandAmount || 0),
          Status: item.status,
          CurrentQuantity: Number(
            item?.schemeSummary?.calculationReference?.[row.vanNo]
              ?.currentQuantity || 0
          ),
          CurrentValue: formatToINR(
            item?.schemeSummary?.calculationReference?.[row.vanNo]
              ?.currentValue || 0
          ),
          // SchemeValue: formatToINR(item?.schemeSummary?.totalValue || 0),
          // SchemeQuantity: Number(item?.schemeSummary?.totalQuantity || 0),
          Remarks: item?.Remarks,
          'Sold/Purchase Quantity': Number(
            item?.schemeSummary?.calculationReference?.[row.vanNo]
              ?.totalPositiveQuantity || 0
          ),
          'Return Quantity': Number(
            item?.schemeSummary?.calculationReference?.[row.vanNo]
              ?.totalNegativeQuantity || 0
          ),
          'Open Quantity': Number(
            item?.schemeSummary?.calculationReference?.[row.vanNo]
              ?.totalOpenQuantity || 0
          ),
          'Closing stock': Number(
            item?.schemeSummary?.calculationReference?.[row.vanNo]
              ?.totalStock || 0
          ),
        };
      })
    );
  const summaryWorksheet = exportExcelWithINRColumns(
    result,
    ['Payout', 'CurrentValue', 'Capping Value/Qty', 'VSAmount', 'Brand Amount'],
    []
  );
  if (needData) return summaryWorksheet;
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, summaryWorksheet, 'Scheme Summary');
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

export const exportSchemeData = (schemeData, data, type, fileName) => {
  // let result = schemeData.flatMap((item) =>
  //   item.products.map((row) => {
  //     const currentProduct = data.find(
  //       (product) => product.vanNo === row.vanNo
  //     );
  //     return {
  //       Brand: item?.company?.join(', '),
  //       SchemeType: item.type[0],
  //       SchemeCircularDate: returnSchemeExcelDate(
  //         item?.schemeCircularDate
  //       ),
  //       SchemeCircularNo: item.schemeCircularNo,
  //       ValidFrom: returnSchemeExcelDate(item?.validFrom),
  //       ValidTill: returnSchemeExcelDate(item?.validTill),
  //       ProductCategory: item?.productCategory?.join(', '),
  //       SubCategory: item?.subCategory?.join(', '),
  //       SubCategory2: item?.subCategory2?.join(', '),
  //       SubCategory3: item?.subCategory3?.join(', '),
  //       Product: row?.productName,
  //       VAN: row?.vanNo,
  //       ValuationType: row?.valuationType,
  //       Payout: row?.payout,
  //       CappingType: row.cappingType?.[0],
  //       'Capping Value/Qty': row?.cappingAmount,
  //       Status: item.status,
  //       SchemeValue: item?.schemeSummary?.totalValue,
  //       SchemeQuantity: item?.schemeSummary?.totalQuantity,
  //       Remarks: item?.Remarks,
  //       'Sold/Purchase Quantity': currentProduct.,
  //       'Return Quantity': '',
  //       'Open Quantity': '',
  //       'Closing stock': '',
  //     };
  //   })
  // );
  let result = [];
  let productsWorksheet = [];
  const currentType =
    type === schemeTypeMap.foc ? schemeData.sellIntype?.[0] : type;
  switch (currentType) {
    case 'Sell-in':
      result = data.map((item) => {
        const obj = {
          PurchaseDate: returnSchemeExcelDate(item.PurchaseDate),
          PurchaseVNo: item.PurchaseVNo,
          Branch: item.Branch,
          Product: item.Product,
          VanNo: item.VanNo,
          Brand: item.company,
          TotalAmount: formatToINR(
            item.TotalQuantity < 0 ? -item.TotalAmount : item.TotalAmount
          ),
          TotalQuantity: Number(item.TotalQuantity),
          TotalIGST: formatToINR(item.TotalIGST),
          TotalCGST: formatToINR(item.TotalCGST),
          TotalSGST: formatToINR(item.TotalSGST),
          Unitrate: Number(item.Unitrate),
          TotalGSTAmount: formatToINR(item.TotalGSTAmount),
          SerialNo: item.SerialNo,
          ReferenceBillNo: item.ReferenceBillNo,
          ReferenceBillDate: returnSchemeExcelDate(item.ReferenceBillDate),
        };
        return obj;
      });
      productsWorksheet = exportExcelWithINRColumns(
        result,
        [
          'TotalAmount',
          'TotalIGST',
          'TotalCGST',
          'TotalSGST',
          'TotalGSTAmount',
        ],
        []
      );
      break;
    case 'Sell-out':
      result = data.map((item) => {
        const obj = {
          OrderNo: item.orderNo,
          OrderDate: returnSchemeExcelDate(item.orderDate?.split('T')[0]),
          Branch: item.branch,
          VanNo: item.vanNo,
          Product: item.product,
          Quantity: Number(item.quantity),
          Amount: formatToINR(item.quantity < 0 ? -item.amount : item.amount),
          CGST: formatToINR(item.CGST),
          SGST: formatToINR(item.SGST),
          IGST: formatToINR(item.IGST),
          GSTAmount: formatToINR(item.gstAmount),
          InvoiceNumber: item.invoiceNo,
          SerialNumber: item.serialNo,
          ProductCode: item.productCode,
          Brand: item.brand,
          ReturnVoucherNo: item.returnVoucherNo,
          Reason: item.reason,
          TowardsVNo: item.towardsVNo,
          OrderType: item.orderType,
        };
        return obj;
      });
      productsWorksheet = exportExcelWithINRColumns(
        result,
        ['Amount', 'IGST', 'CGST', 'SGST', 'GSTAmount'],
        []
      );
      break;
    default:
      productsWorksheet = exportExcelWithINRColumns(data, [], []);
      break;
  }
  // Create workbook and save
  const summaryWorksheet = exportSchemeDataSummary([schemeData], '', true);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, summaryWorksheet, 'Scheme Summary');
  XLSX.utils.book_append_sheet(workbook, productsWorksheet, 'Products Data');
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

export const exportSchemeIndexReport = (data) => {
  const result =
    data &&
    data?.flatMap((item) =>
      item.products.map((row) => ({
        SchemeNo: item.voucherNumber,
        Brand: item?.company?.join(', '),
        SchemeType: item.type[0],
        SchemeCircularDate: returnSchemeExcelDate(item?.schemeCircularDate),
        SchemeCircularNo: item.schemeCircularNo,
        ValidFrom: returnSchemeExcelDate(item?.validFrom),
        ValidTill: returnSchemeExcelDate(item?.validTill),
        ProductCategory: item?.productCategory?.join(', '),
        SubCategory: item?.subCategory?.join(', '),
        SubCategory2: item?.subCategory2?.join(', '),
        SubCategory3: item?.subCategory3?.join(', '),
        Product: row?.productName,
        VAN: row?.vanNo,
        ValuationType: row?.valuationType,
        Payout: row?.payout,
        PayoutBasis: item.payoutBasis?.[0] || row?.payoutBasis?.[0],
        CappingType: row.cappingType?.[0],
        'Capping Value/Qty': Number(row?.cappingAmount),
        Status: item.status,
        Target: row.target,
        VSAmount: formatToINR(row.vsAmount),
        'Brand Amount': formatToINR(row.brandAmount),
      }))
    );
  return result;
};

export const exportExcelWithINRColumns = (
  data,
  inrColumns = [],
  noDecimalColumns = []
) => {
  if (!data?.length) return;

  // Convert formatted INR strings to numbers
  const cleanedData = data.map((row) => {
    const newRow = { ...row };
    inrColumns.forEach((key) => {
      const value = row[key];
      if (typeof value === 'string') {
        const numericValue = Number(value.replace(/,/g, ''));
        if (!isNaN(numericValue)) newRow[key] = numericValue;
      }
    });
    return newRow;
  });

  // Create worksheet
  const worksheet = XLSX.utils.json_to_sheet(cleanedData);

  // Map column names to Excel letters
  const columnHeaders = Object.keys(data[0]);
  const columnLetterMap = {};
  columnHeaders.forEach((header, index) => {
    columnLetterMap[header] = XLSX.utils.encode_col(index);
  });

  // Apply number formatting to specified INR columns
  cleanedData.forEach((_, rowIndex) => {
    const rowNumber = rowIndex + 2;
    inrColumns.forEach((key) => {
      const col = columnLetterMap[key];
      const cellAddress = `${col}${rowNumber}`;
      if (worksheet[cellAddress]) {
        worksheet[cellAddress].z = '#,##0.00';
      }
    });
    noDecimalColumns.forEach((key) => {
      const col = columnLetterMap[key];
      const cellAddress = `${col}${rowNumber}`;
      if (worksheet[cellAddress]) {
        worksheet[cellAddress].z = '#,##0'; // Comma-separated, no decimal
      }
    });
  });

  return worksheet;
};
